import React, { useCallback, useContext, useEffect, useRef } from 'react'
import { SkillBiteEditSlice } from '../../../reducers'
import { useDispatch, useSelector } from 'react-redux'
import { Box } from '@mui/material'
import SessionSelector from './components/session-selector'
import EmailConfigForm from './components/email-config-form'
import { appFooterContainerId } from '../../../layouts/primary-layout'
import { useConfirm } from 'material-ui-confirm'
import { TabChangeGuardContext } from '..'
import { EmptyIndicatorMessage } from '../build/components/empty-indicator'

export const EmailNavigationContext = React.createContext(null)

const Email = () => {
  const skillBite = useSelector(SkillBiteEditSlice.selectors.selectSkillBite)
  const { sessions } = skillBite
  const selectedSession = useSelector(SkillBiteEditSlice.selectors.selectSelectedSession)
  const { tabChangeGuard } = useContext(TabChangeGuardContext)
  const emailFormRef = useRef()
  const confirm = useConfirm()
  const dispatch = useDispatch()
  const canEdit = useSelector(SkillBiteEditSlice.selectors.selectEditMode)

  const discardChangesOnNavigationGuard = useCallback((callback) => {
    const pageBlockForm = emailFormRef.current
    if (pageBlockForm?.formState.isDirty && canEdit) {
      confirm({
        title: 'Discard changes?',
        description: 'You have unsaved changes on your session email config form, are you sure you want to exit without saving?',
        confirmationText: 'Yes, discard',
        cancellationText: 'No, keep editing'
      })
        .then(callback)
        .catch(() => { })
      return
    }

    callback()
  }, [confirm, canEdit])

  useEffect(() => {
    document.getElementById(appFooterContainerId).style.display = 'none'
    return () => {
      document.getElementById(appFooterContainerId).style.display = 'block'
    }
  }, [])

  useEffect(() => {
    if (tabChangeGuard) {
      tabChangeGuard.current = discardChangesOnNavigationGuard
    }
    return () => {
      if (tabChangeGuard) {
        tabChangeGuard.current = null
      }
    }
  }, [tabChangeGuard, discardChangesOnNavigationGuard])

  const changeSelectedSession = useCallback((session) => {
    discardChangesOnNavigationGuard(() => {
      dispatch(SkillBiteEditSlice.actions.changeSelectedSession(session))
    })
  }, [dispatch, discardChangesOnNavigationGuard])

  if (!sessions?.length) {
    return (
      <EmptyIndicatorMessage
        title='No sessions yet'
        subtitle='You can create sessions on the Build tab'
      />
    )
  }

  return (
    <EmailNavigationContext.Provider value={{ emailFormRef, changeSelectedSession, discardChangesOnNavigationGuard }}>
      <Box display='flex' flexDirection='row' sx={{ padding: '16px' }}>
        <Box sx={{ width: '30%' }}>
          <SessionSelector sessions={sessions} />
        </Box>
        <Box display='flex' flexDirection='row' sx={{ flex: 1, p: 2, pr: 0 }}>
          {selectedSession && <EmailConfigForm session={selectedSession} />}
        </Box>
      </Box>
    </EmailNavigationContext.Provider>
  )
}

export default Email
